/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IStackItemStyles } from '@fluentui/react/lib/Stack';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { CSSProperties } from 'react';
import { FontSizes } from '../../../../../styles/teams';

export const getTitleStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.black,
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.bold,
            height: '1.25rem',
            lineHeight: '1.25rem',
            padding: 0,
        },
    };
};

export const getBodyStyles = (): Partial<IStackItemStyles> => {
    return {
        root: {
            marginTop: '2.5rem !important',
            marginBottom: '1.56rem',
            overflowY: 'auto',
            overflowX: 'hidden',
            marginLeft: '-2rem',
            marginRight: '-2rem',
        },
    };
};

export const getScrollContainerStyle = (): Partial<CSSProperties> => {
    return { paddingLeft: '2rem', paddingRight: '2rem' };
};
